<template>
  <el-col v-if="bid.id" :span="14">
    <el-card class="box-card shipping_card">
      <div class="shipping_info">
        <el-row>
          <el-col :span="12">
            <p class="number_date">
              Перевозка № {{ bid.id }}.
              {{ dateCreate() }}
            </p>
          </el-col>
          <el-col :span="12" class="shipping_info_right">
            <p v-if="canAction('shipping_stat')" class="weight">
              Всего: {{ bid.weight }} т., выгружено: 0 т., на колесах 0 т
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18" class="shipping-row">
            <div>
              <h2 class="d_h2">{{ loadLocationFilter(bid) }}</h2>
              <p class="ri_p1">{{ bid.load_point.split(',')[0] }}</p>
            </div>
            <div class="sh_dist">
              <img src="@/assets/img/arrow-route.svg" alt="" />
              <p class="ri_p2">{{ bid.distance }} км</p>
            </div>
            <div>
              <h2 class="d_h2">{{ findStevedore(bid) }}</h2>
              <p class="ri_p1">{{ bid.unload_point.split(',')[1] }}</p>
            </div>
          </el-col>
          <el-col
            :span="6"
            class="shipping-row"
            style="display: flex; flex-direction: column; align-items: flex-end"
          >
            <h2 class="d_h2">
              <img src="@/assets/img/grass.svg" alt="" />
              {{ freightsType }}
            </h2>

            <p v-if="getSZVM" class="ri_p1">
              СЗВМ:
              <span>
                {{ getSZVM }}
              </span>
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div v-if="!isDispatcherRole" class="customer-price">
              <el-col :span="5">
                <b>Заказчик:</b>
              </el-col>
              <el-col :span="9">
                {{ bid['client_short_name'] || 'NaN' }}
              </el-col>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin: 10px 0 5px">
          <el-col :span="24">
            <div v-if="!isDispatcherRole" class="customer-price">
              <el-col :span="5">
                <b>Цена заказчика:</b>
              </el-col>
              <el-col :span="9">
                <template v-if="bid.type_code !== 'harvest'">
                  {{ currentDay.price_from_storage_bidder | getPrice }}
                  <span v-if="bid.type_code === 'harvest_or_delivery'">
                    (Перевозка),
                  </span>
                </template>
                <template v-if="bid.type_code !== 'delivery'">
                  {{ currentDay.price_from_field_bidder | getPrice }}
                  <span v-if="bid.type_code === 'harvest_or_delivery'">
                    (Уборка)
                  </span>
                </template>
              </el-col>
              <el-col :span="10">
                <div
                  v-if="currentDay.status === 1"
                  class="load-day-status__status"
                >
                  <span class="day-status">(День закрыт)</span>
                </div>
              </el-col>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="load-day-select">
              <el-row type="flex" align="middle">
                <el-col :span="5">
                  <b>Дата погрузки:</b>
                </el-col>
                <el-col :span="9">
                  <el-select
                    :value="activeDayDate"
                    placeholder="выбраыть день..."
                    size="mini"
                    class="el-input__choose-day"
                    @change="handleSelectDate"
                  >
                    <el-option
                      v-for="(item, i) in loadDaysDatesOptions"
                      :key="`${item.value}_${i}`"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="10">
                  <div class="load-day-status">
                    <div
                      v-if="canAction('changeDayStatus')"
                      class="load-day-status__btn"
                    >
                      <el-button
                        class="red"
                        :loading="isDayLoading"
                        :type="currentDay.status === 1 ? 'success' : 'danger'"
                        :icon="`el-icon-${
                          currentDay.status === 1 ? 'check' : 'close'
                        }`"
                        size="small"
                        @click="handleOpenCloseDay(currentDay)"
                      >
                        {{
                          currentDay.status === 1
                            ? 'Открыть день'
                            : 'Закрыть день'
                        }}
                      </el-button>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import {
  FETCH_CURRENT_LOAD_DAY,
  UPDATE_STATUS_LOAD_DAY,
} from '@/store/actions/loadDay'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import * as DateFormats from '@/datas/DateFormats'
import { checkDate } from '@/helpers/functions'
import { getDateOfCertainFormat } from '@/helpers/date'

import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'HeaderLoadDay',
  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadDaysDatesOptions: [],
    }
  },
  computed: {
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
      getLoading: 'loadDay/getLoading',
      currentDay: 'loadDay/getCurrentLoadDay',
    }),
    getSZVM() {
      const { client_szvm_required } = this.bid

      if (client_szvm_required === 1) {
        return 'требует'
      }

      return null
    },
    isDayLoading() {
      return this.getLoading()
    },
    freightsType() {
      return this.getLibObj('freightTypes')[this.bid.freight_id]
    },
    activeDayDate() {
      return checkDate(this.currentDay.load_date)
    },
  },
  watch: {
    'bid.id': {
      immediate: true,
      handler(id) {
        if (id) {
          this.initSelectDate()
        }
      },
    },
  },
  methods: {
    ...mapActions({ updateDay: `loadDay/${UPDATE_STATUS_LOAD_DAY}` }),
    ...mapMutations({ selectDay: `loadDay/${FETCH_CURRENT_LOAD_DAY}` }),
    dateCreate() {
      return this.bidDatesText(
        this.bid.created_at,
        'Дата создания',
        DateFormats.shortDateWithoutYear,
      )
    },
    bidDatesText(dateField, description, dateFormat) {
      const formattedDateCreate = getDateOfCertainFormat(dateField, dateFormat)

      return formattedDateCreate ? `${description} ${formattedDateCreate}` : ``
    },
    initSelectDate() {
      this.loadDaysDatesOptions =
        this.bid['load_days']?.map(day => ({
          value: day.load_date,
          label: checkDate(day.load_date),
        })) || []
    },
    async handleSelectDate(value) {
      const selectDay = this.bid['load_days']?.find(c => c.load_date === value)

      if (selectDay) {
        await this.selectDay(selectDay.id)
        await this.$router.push({
          name: 'LoadDay',
          params: {
            bidId: this.bid.id,
            loadDayId: selectDay.id,
          },
        })
      }
    },
    async handleOpenCloseDay(day) {
      const status = day.status === 1 ? 0 : 1

      await this.updateDay({ id: day.id, status })
    },
  },
}
</script>
